<template>
  <div class="hex-badge" :class="{ locked }">
    <div class="hex-border">
      <div class="hex-fill">
        <Icon v-if="isIconifyIcon" :icon="icon" class="badge-icon" />
        <span v-else class="badge-glyph">{{ icon }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Icon } from '@iconify/vue';

const props = defineProps<{
  icon: string;
  label: string;
  locked?: boolean;
}>();

const isIconifyIcon = computed(() => props.icon.includes(':'));
</script>

<style scoped>
.hex-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
}

.hex-border {
  width: 100%;
  height: 100%;
  background: #8b5a2b;
  clip-path: polygon(50% 0%, 93% 25%, 93% 75%, 50% 100%, 7% 75%, 7% 25%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.hex-fill {
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  background: var(--hw-bg-surface);
  clip-path: polygon(50% 0%, 93% 25%, 93% 75%, 50% 100%, 7% 75%, 7% 25%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-icon {
  font-size: 24px;
  color: var(--hw-text);
}

.badge-glyph {
  font-size: 18px;
  font-weight: bold;
  color: var(--hw-text);
}

.locked .hex-border {
  background: #4a3020;
}

.locked .hex-fill {
  background: var(--hw-bg-deep);
}

.locked .badge-icon,
.locked .badge-glyph {
  color: #4a3020;
}
</style>
